import EventDispatcher from 'seng-event';
import TaskLoader from 'task-loader/lib/TaskLoader';
import type LoadImageTask from 'task-loader/lib/task/LoadImageTask';
import type LoadJsonTask from 'task-loader/lib/task/LoadJsonTask';
import TaskLoaderEvent from 'task-loader/lib/event/TaskLoaderEvent';
import type { ITaskLoaderEventData } from 'task-loader/lib/interface/ITaskLoaderEventData';
import type LoadMethodTask from './util/task-loader/LoadMethodTask';
import type LoadFontMethodTask from './util/task-loader/LoadFontMethodTask';
import type LoadProgressMethodTask from './util/task-loader/LoadProgressMethodTask';

export default class AppPreloader extends EventDispatcher {
  public taskLoader: TaskLoader;
  private taskLoaderOptions: {
    onUpdate?: (progress: number) => void;
    onComplete?: () => void;
  } | null = null;
  private readonly tasks: Array<
    LoadImageTask | LoadMethodTask | LoadJsonTask | LoadFontMethodTask | LoadProgressMethodTask
  > = [];

  public constructor() {
    super();

    this.taskLoader = new TaskLoader();
    this.taskLoader.addEventListener(TaskLoaderEvent.UPDATE, this.onUpdate.bind(this));
    this.taskLoader.addEventListener(TaskLoaderEvent.COMPLETE, this.onComplete.bind(this));
  }

  public addTask(
    task: LoadImageTask | LoadMethodTask | LoadFontMethodTask | LoadProgressMethodTask,
  ): void {
    this.tasks.push(task);
  }

  public start(options: {
    onUpdate?: (progress: number) => void;
    onComplete?: () => void;
  }): Promise<boolean | void> {
    return this.loadTasks(this.tasks, options);
  }

  private onUpdate(event: unknown): void {
    if (this.taskLoaderOptions && this.taskLoaderOptions.onUpdate) {
      this.taskLoaderOptions.onUpdate((event as { data: ITaskLoaderEventData }).data.progress);
    }
  }

  private onComplete(): void {
    if (this.taskLoaderOptions && this.taskLoaderOptions.onComplete) {
      this.taskLoaderOptions.onComplete();
    }
  }

  public loadTasks(
    tasks: Array<
      LoadImageTask | LoadMethodTask | LoadJsonTask | LoadFontMethodTask | LoadProgressMethodTask
    >,
    options: { onUpdate?: (progress: number) => void; onComplete?: () => void },
  ): Promise<boolean | void> {
    this.taskLoaderOptions = options || null;
    return this.taskLoader.loadTasks(tasks);
  }

  public dispose(): void {
    super.dispose();
  }
}
